import { Message } from 'element-ui';

const defaultOptions = {
  time: 3 * 1000
}
const showMsg = ({ type = 'success', msg, time }) => {
  if (msg === '' || msg == null) return
  Message({
    message: msg,
    type: type == null ? 'success' : type,
    duration: time,
  })
}

export function ok(msg, options = defaultOptions) {
  showMsg({ msg, time: options.time })
}
export function ng(msg, options = defaultOptions) {
  showMsg({ type: 'error', msg, time: options.time })
}
export function warn(msg, options = defaultOptions) {
  showMsg({ type: 'warning', msg, time: options.time })
}


// WEBPACK FOOTER //
// ./src/utils/msg.js